module.exports = __webpack_public_path__ + "img/icon-cloud.6909bb31.png";